<script lang="ts" setup>
import { LoaderBlockDomain } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonAllLessons',
})

</script>

<template>
  <div class="skeleton-all-lessons">
    <LoaderBlockDomain />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonAllLessons.scss" />
